<template>
  <div>
    <b-table responsive :class="['mb-3', tableClass]" head-variant="dark" borderless striped hover :items="items"
      :fields="fields" :filter="filter" @filtered="onTableFiltered" :current-page="localCurrentPage" :per-page="perPage"
      show-empty sort-icon-left>
      <template #empty>
        <div style="text-align: center">
          <span>{{ $t("Gral.noRegistros") }}</span>
        </div>
      </template>
      <template #emptyfiltered>
        <div style="text-align: center">
          <span>{{ $t("Gral.busquedaFallida") }}</span>
        </div>
      </template>

      <template v-for="(_, slotName) in $scopedSlots" #[slotName]="data">
        <slot :name="slotName" v-bind="data"></slot>
      </template>
    </b-table>

    <div class="d-flex justify-content-center">
      <b-pagination class="pagination-movil" v-model="localCurrentPage" :total-rows="totalRows" :per-page="perPage"
        @input="$emit('update:currentPage', localCurrentPage)" align="fill">
      </b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableClass: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 3,
    },
    filter: {
      type: String,
      default: "",
    },
    totalRows: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      localCurrentPage: this.currentPage,
    };
  },
  watch: {
    currentPage(newVal) {
      this.localCurrentPage = newVal;
    },
    localCurrentPage(newVal) {
      this.$emit("update:currentPage", newVal);
    },
  },
  methods: {
    onTableFiltered(filteredItems) {
      this.$emit("filtered", filteredItems.length);
    },
  },
};
</script>

<style>
@media (min-width: 2560px) {
  /* --- TABLA --- */

  /* Aumentar tamaño de letra en celdas y encabezados */
  .b-table,
  .table {
    font-size: 1.6rem !important;
  }

  /* Encabezados más altos y con texto grande */
  .table thead th {
    padding: 1.5rem !important;
    font-size: 1.8rem !important;
  }

  /* Filas con más espacio (padding) */
  .table tbody td {
    padding: 1.5rem !important;
    vertical-align: middle !important;
  }

  /* --- PAGINACIÓN --- */

  /* Contenedor de la paginación */
  .pagination-movil {
    margin-top: 2rem !important;
  }

  /* Escalar los botones de la paginación (1, 2, 3, Siguiente, etc.) */
  .pagination-movil .page-item .page-link {
    min-width: 70px !important;
    height: 70px !important;
    font-size: 1.8rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 5px !important;
    border-radius: 10px !important;
  }

  /* Ajuste para los iconos de flechas dentro de la paginación */
  .pagination-movil .page-item span {
    font-size: 2rem !important;
  }

  /* 1. Forzar tamaño si son iconos SVG (Bootstrap Icons) */
  .b-table th .b-icon.bi,
  .table th svg {
    width: 1.5rem !important;
    height: 2rem !important;
    vertical-align: middle !important;
    margin-left: 8px !important;
  }

  /* 2. Forzar tamaño si son fuentes (FontAwesome / Glyphicons) */
  .table th .sr-only+i,
  .table th [class^="icon-"],
  .table th [class*=" icon-"] {
    font-size: 2rem !important;
    display: inline-block !important;
    vertical-align: middle !important;
  }

  /* 3. Ajuste para el contenedor de la flecha en BootstrapVue */
  /* Algunas versiones envuelven la flecha en un span con clase 'sr-only' */
  .table th.sorting::after,
  .table th.sorting_asc::after,
  .table th.sorting_desc::after {
    font-family: inherit !important;
    font-size: 2.2rem !important;
    line-height: 1 !important;
    right: 1.5rem !important;
    content: "" !important;
    /* Si usa imágenes de fondo, esto las escala */
  }

  /* 4. Si las flechas son imágenes de fondo (Background images) */
  .table.b-table>thead>tr>th[aria-sort] {
    background-size: 33px !important;
    /* Aumenta el tamaño de la flecha si es imagen */
    background-position: right 1.3rem center !important;
    padding-right: 5rem !important;
    /* Da espacio para que la flecha no pise el texto */
  }


}

@media (max-width: 959px) {
  .pagination-movil {
    width: 100%;
  }
}
</style>